import BaseButton from 'components/atoms/baseButton';
import { t } from 'i18next';

import s from './pap-case-details-modal.module.scss';

import type { Dispatch, FC, SetStateAction } from 'react';
import type { PapCaseStatus } from '../../types';

type PapCaseControllersProps = {
  caseStatus: PapCaseStatus;
  handleReadyForReview: (
    caseStatus: PapCaseStatus,
    nextStatus: PapCaseStatus,
  ) => void;
  handleOpenCaseReview: Dispatch<SetStateAction<PapCaseStatus | null>>;
  isDisabled?: boolean;
  isReviewerView?: boolean;
};

const PapCaseControllers: FC<PapCaseControllersProps> = ({
  caseStatus,
  handleReadyForReview,
  handleOpenCaseReview,
  isDisabled = false,
  isReviewerView = false,
}) => {
  if (caseStatus === 'draft') {
    return (
      <BaseButton
        label={t('papCase.readyForReview')}
        onClick={() => handleReadyForReview(caseStatus, 'in-review')}
        disabled={isDisabled}
      />
    );
  }
  if (caseStatus === 'needs-info') {
    if (isReviewerView) {
      return (
        <p className={s['reviewer-waiting-message']}>
          {t('papCase.waitingForNurseResubmit')}
        </p>
      );
    }
    return (
      <BaseButton
        label={t('papCase.readyForReview')}
        onClick={() => handleReadyForReview(caseStatus, 'in-review')}
        disabled={isDisabled}
      />
    );
  }

  if (caseStatus === 'in-review') {
    if (!isReviewerView) {
      return <BaseButton label={t('papCase.readyForReview')} disabled />;
    }
    return (
      <div className={s['controller-buttons-row']}>
        <BaseButton
          label={t('papCase.requestMoreInfo')}
          onClick={() => handleOpenCaseReview('needs-info')}
          type="secondary"
        />
        <BaseButton
          label={t('papCase.submitToExternal')}
          onClick={() => handleOpenCaseReview('submitted')}
        />
      </div>
    );
  }
  if (caseStatus === 'submitted') {
    if (!isReviewerView) {
      return null;
    }
    return (
      <div className={s['controller-buttons-row']}>
        <BaseButton
          label={t('papCase.requestMoreInfo')}
          onClick={() => handleOpenCaseReview('needs-info')}
          type="secondary"
        />
        <BaseButton
          label={t('papCase.deny')}
          onClick={() => handleOpenCaseReview('denied')}
          type="red-text"
        />
        <BaseButton
          label={t('papCase.approve')}
          onClick={() => handleOpenCaseReview('approved')}
        />
      </div>
    );
  }
  if (caseStatus === 'approved') {
    if (!isReviewerView) return null;
    return (
      <p className={s['reviewer-waiting-message']}>
        {t('papCase.caseApprovedNoActions')}
      </p>
    );
  }
  if (caseStatus === 'denied') {
    if (!isReviewerView) return null;
    return (
      <p className={s['reviewer-waiting-message']}>
        {t('papCase.caseDeniedNoActions')}
      </p>
    );
  }
  return null;
};

export default PapCaseControllers;
